import { DetailedRound } from "../../../models/round";
import useDetailRound from "../../../rounds/useDetailRound";
import { getTheGameManifest, isTheGameRoundName, TheGameManifest } from "./thegamemanifest";

interface RoundLike {
  id: string;
  name: string;
  promotionalValues?: DetailedRound["promotionalValues"];
}

// Round lists (shallow rounds) don't carry promotional values, so the manifest is read from the detailed round.
export default function useTheGameManifest(round?: RoundLike, refetchInterval?: number): { manifest?: TheGameManifest; detailedRound?: DetailedRound } {
  const inline = getTheGameManifest(round);
  const needsDetail = !inline && !!round && isTheGameRoundName(round.name);
  const { round: detailedRound } = useDetailRound(needsDetail ? round!.id : undefined, { enabled: needsDetail, refetchInterval });
  return {
    manifest: inline ?? (needsDetail ? getTheGameManifest(detailedRound) : undefined),
    detailedRound: needsDetail ? detailedRound : undefined,
  };
}
